export enum OmRolesEnum {
    ADMINISTRATOR = 'Administrator',
    PARENT_USER = 'Parent User',
    IT_USER = 'IT User',
    ASSAY_DESIGNER = 'Assay Designer',
    BETA_TESTER = 'Beta Tester',
    PROJECT_MANAGER = 'Project Manager',
    PRICING_ADMINISTRATOR = 'Pricing Administrator',
    SALES = 'Sales',
    CENTRAL_BILLING_ADMINISTRATOR = 'Central Billing Administrator',
    CENTRAL_SHIPPING_ADMINISTRATOR = 'Central Shipping Administrator',
    QUALITY_ASSURANCE = 'Quality Assurance',
    ASSAY_DESIGN_MANAGER = 'Assay Design Manager',
    CENTRAL_SHIPPING_USER = 'Central Shipping User',
    TRANSNETYX_QUALITY_ASSURANCE = 'Transnetyx Quality Assurance',
    CENTRAL_BILLING_USER = 'Central Billing User',
    EXPERT_USER = 'Expert User',
    ORIGINAL_BETA_USER = 'Original Beta User',
    ORGANIZATION_CONTACT = 'Organization Contact',
    REGIONAL_ACCOUNT_SPECIALIST = 'Regional Account Specialist',
    SHIPPING_AND_RECEIVING = 'ShippingAndReceiving',
    AFFILIATE_ADMINISTRATOR = 'Affiliate Administrator',
    ANIMAL_FACILITY_MANAGER = 'Animal Facility Manager',
    SALES_MANAGER = 'Sales Manager',
    ACCOUNTING = 'Accounting',
    MARKETING = 'Marketing',
    INTERNATIONAL_DISTRIBUTION_SHIPPER = 'International Distribution Shipper',
    REGIONAL_SALES_DIRECTOR = 'Regional Sales Director',
    REGIONAL_SALES_MANAGER = 'Regional Sales Manager',
    REGIONAL_ACCOUNT_MANAGER = 'Regional Account Manager',
    GENETIC_MONITORING_FIELD_SPECIALIST = 'Genetic Monitoring Field Specialist',
    MICROBIOME_FIELD_SPECIALIST = 'Microbiome Field Specialist',
    TISSUE_FIELD_SPECIALIST = 'Tissue Field Specialist',
    COLONY_FIELD_SPECIALIST = 'Colony Field Specialist',
    LARAGEN_FIELD_SPECIALIST = 'Laragen Field Specialist',
    GENETIC_MONITORING_PRODUCT_SPECIALIST = 'Genetic Monitoring Product Specialist',
    MICROBIOME_PRODUCT_SPECIALIST = 'Microbiome Product Specialist',
    TISSUE_PRODUCT_SPECIALIST = 'Tissue Product Specialist',
    COLONY_PRODUCT_SPECIALIST = 'Colony Product Specialist',
    LARAGEN_PRODUCT_SPECIALIST = 'Laragen Product Specialist',
    AMI_PRODUCT_SPECIALIST = 'AMI Product Specialist',
    AMI_FIELD_SPECIALIST = 'AMI Field Specialist',
}
